import axios from 'axios'
import Api from "../apis";

import { sweetAlertToaster } from '../../modules/custom-item/helper';
import customAxios from '../../utilities/customAxios';

export const getDepth = ({ commit }, params) => {
    commit('setDepth', params);
}

export const getProducts = ({ commit }) => {
    getFullPageLoader();
    customAxios.get('/custom-item/cutting-board/products').then((res) => {
        let item = JSON.parse(res.data);
        commit('SET_PRODUCTS',item.products);
        removeFullPageLoader();
    })
        .catch((err) => {
            ShowNotification('error', 'Order', err.response.data.error);
            removeFullPageLoader();
        })
}
export const getDepthFract = ({ commit }, params) => {
    commit('setDepthFract', params);
}

export const setThickness = ({ commit }, event) => {
    let thickness = event.target.value;
    commit('SET_THICKNESS', thickness);
    commit('SET_PRICE');
}

export const setQty = ({commit},event) => {
    let qty = Number.isInteger(event)?event:event.target.value;
    commit('SET_QTY',qty);
}

export const addToCart = ({state, commit ,getters}, swal) => {
    let depth = state.shelf_depth;
    let width = state.shelf_width;
    let selling_price = state.selling_price;
    let qty = state.qty;
    let thickness = state.thickness;
    let product = state.product;
    let totalSquareInches = getters.totalSquareInches;
    let totalPrice = getters.totalPrice;
    const [width_floor,width_fract] = state.width_display.split('-');
    const [depth_floor,depth_fract] = state.depth_display.split('-');
    let OrderSpec = `${qty}EA, ${width_floor} ${width_fract !=undefined?width_fract:''}W X ${depth_floor} ${depth_fract!=undefined?depth_fract:''}L`;

    const formData = new FormData();
    formData.append('depth',depth);
    formData.append('width',width);
    formData.append('selling_price',selling_price);
    formData.append('qty',qty);
    formData.append('thickness',thickness);
    formData.append('product',product);
    formData.append('totalSquareInches',totalSquareInches);
    formData.append('totalPrice',totalPrice);
    formData.append('OrderSpec',OrderSpec);
    customAxios.post('/custom-item/cutting-board/add-to-cart',formData).then((res)=>{
        sweetAlertToaster(swal,res.data.cart_summary,res.data.shop);
        
    })
    .catch((err)=>{
        console.log(err)
        ShowNotification('error', 'Order', err.response.data.error);
        
    });
    
}

